<template>
  <v-dialog v-model="openMode" max-width="500px">
    <v-card class="permissions-dialog">
      <v-card-title class="dialog-header">
        <v-icon left class="ml-2" dark>mdi-shield-account</v-icon>
        הרשאות
      </v-card-title>

      <v-card-text>
        <v-container class="permissions-container">
          <v-row>
            <v-col cols="12">
              <v-card class="permission-card" outlined>
                <v-card-text>
                  <v-checkbox v-model="permissionsToEdit.confRoom" hide-details color="#0d2c6d"
                    class="permission-checkbox">
                    <template v-slot:label>
                      <div class="permission-label">
                        <v-icon color="#0d2c6d" small class="ml-2">mdi-account-group</v-icon>
                        חדר ועידה
                      </div>
                    </template>
                  </v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card class="permission-card" outlined>
                <v-card-text>
                  <v-checkbox v-model="permissionsToEdit.playSubscribersNumbers" hide-details color="#0d2c6d"
                    class="permission-checkbox">
                    <template v-slot:label>
                      <div class="permission-label">
                        <v-icon color="#0d2c6d" small class="ml-2">mdi-account-details</v-icon>
                        השמעת פרטי החברים בקבוצה
                      </div>
                    </template>
                  </v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card class="permission-card" outlined>
                <v-card-text>
                  <v-checkbox v-model="permissionsToEdit.all_can_record_public" hide-details color="#0d2c6d"
                    class="permission-checkbox">
                    <template v-slot:label>
                      <div class="permission-label">
                        <v-icon color="#0d2c6d" small class="ml-2">mdi-account-details</v-icon>
                        כולם יכולים להקליט הודעות ציבוריות
                      </div>
                    </template>
                  </v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card class="permission-card" outlined>
                <v-card-text>
                  <v-checkbox v-model="permissionsToEdit.all_can_record_private" hide-details color="#0d2c6d"
                    class="permission-checkbox">
                    <template v-slot:label>
                      <div class="permission-label">
                        <v-icon color="#0d2c6d" small class="ml-2">mdi-account-details</v-icon>
                        כולם יכולים להקליט הודעות פרטיות
                      </div>
                    </template>
                  </v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card class="permission-card" outlined>
                <v-card-text>
                  <v-checkbox v-model="permissionsToEdit.share_record" hide-details color="#0d2c6d"
                    class="permission-checkbox">
                    <template v-slot:label>
                      <div class="permission-label">
                        <v-icon color="#0d2c6d" small class="ml-2">mdi-account-details</v-icon>
                        שיתוף הודעות עם תא קולי אחר
                      </div>
                    </template>
                  </v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card class="permission-card" outlined>
                <v-card-text>
                  <v-checkbox v-model="permissionsToEdit.like" hide-details color="#0d2c6d" class="permission-checkbox">
                    <template v-slot:label>
                      <div class="permission-label">
                        <v-icon color="#0d2c6d" small class="ml-2">mdi-account-details</v-icon>
                        סימון אהבתי להודעות
                      </div>
                    </template>
                  </v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card class="permission-card" outlined>
                <v-card-text>
                  <v-checkbox v-model="permissionsToEdit.surveys" hide-details color="#0d2c6d"
                    class="permission-checkbox">
                    <template v-slot:label>
                      <div class="permission-label">
                        <v-icon color="#0d2c6d" small class="ml-2">mdi-poll</v-icon>
                        סקרים (שלוחה 11)
                      </div>
                    </template>
                  </v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">

              <v-card class="permission-card" outlined>

                <v-card-text>

                  <v-checkbox v-model="permissionsToEdit.aiAssistant" hide-details color="#0d2c6d"
                    class="permission-checkbox">

                    <template v-slot:label>

                      <div class="permission-label">

                        <v-icon color="#0d2c6d" small class="ml-2">mdi-robot-outline</v-icon>

                        עוזר קולי (AI) בשלוחה 3

                      </div>

                    </template>

                  </v-checkbox>

                </v-card-text>

              </v-card>

            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="dialog-actions">
        <v-btn color="primary" class="save-button" @click="saveChanges()" :loading="progressShow"
          :disabled="progressShow">
          <v-icon left>mdi-content-save</v-icon>
          שמור שינויים
        </v-btn>
        <v-btn color="grey lighten-3" @click="closeDelete">
          סגור
        </v-btn>
      </v-card-actions>
    </v-card>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
  props: {
    ivr: Object,
    value: { type: Boolean, default: false },
  },
  components: {
    SnackBar,
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    newLine: "",
    permissionsToEdit: {},
    sendCall: false,
  }),

  methods: {
    async saveChanges() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        const permissionsJSON = JSON.stringify({ permissionsObj: this.permissionsToEdit, lineNumber: this.ivr.line_number });

        const api = process.env.VUE_APP_BASE_URL + "/admin_api/change_ivr_permissions";
        const res = await fetch(api, ApiServices.requestOptions("POST", permissionsJSON, token));
        const jsonObject = await res.json();
        if (res.status >= 400) {
          this.showSnackBar("שגיאה בשמירת ההרשאות ", "red");
          this.progressShow = false;
        } else if (res.status === 200) {
          this.progressShow = false;
          this.$emit("ivrPermissionsChanged", this.permissionsToEdit)
          this.showSnackBar("השינויים נשמרו בהצלחה!", "green");
          this.openMode = false;
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("שגיאה בשמירת השינויים : " + error, "red");
      }
    },
    closeDelete() {
      this.openMode = false;
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },
  },
  computed: {
    openMode: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
  },
  mounted() {
    this.permissionsToEdit = { ...this.ivr.exten_permissions };
    console.log(this.permissionsToEdit);
  },
}
</script>

<style scoped>
.permissions-dialog {
  border-radius: 12px;
  overflow: hidden;
  direction: rtl;
  font-family: 'Heebo', sans-serif;
}

.dialog-header {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.permissions-container {
  padding: 16px 0;
}

.permission-card {
  border-radius: 8px;
  transition: all 0.3s ease;
  margin-bottom: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.permission-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-color: #0d2c6d;
}

.permission-checkbox {
  margin: 0;
}

.permission-label {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #0d2c6d;
}

.dialog-actions {
  padding: 16px;
  display: flex;
  justify-content: flex-start;
}

.save-button {
  background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%) !important;
  color: #0d2c6d !important;
  font-weight: 600;
  margin-left: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.save-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .dialog-actions {
    flex-direction: column;
  }

  .save-button {
    margin-left: 0;
    margin-bottom: 8px;
    width: 100%;
  }
}
</style>